export function getYesterday() {
  const today = new Date()
  const yesterday = new Date(today.toISOString())
  yesterday.setDate(today.getDate() - 1)
  yesterday.setUTCHours(0, 0, 0, 0)
  return yesterday
}
